module.exports = __webpack_public_path__ + "team-roster-slider-bg.b005ac15da58c2ecb031.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/assets/images/team-roster-slider-bg.jpg
// module id = ../../../../../src/assets/images/team-roster-slider-bg.jpg
// module chunks = styles